export default {
  TOKEN: 'TOKEN',
  PUBLIC_KEY: 'PUBLIC_KEY',
  CLIENT_ID: 'CLIENT_ID',
};
